import { Company } from "./Types/companyTypes";

export const companyValues: Company = {
	id: 0,
	name: "",
	nip: "",
	regon: "",
	email: "",
	phone: "",
	street: "",
	buildingNumber: "",
	apartmentNumber: "",
	postalCode: "",
	city: "",
	country: "",
};
